<match-display-wrapper
    matchLabel="{{ globalL10nKeys.protocolLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
>
    <div>
        {{ protocolType }}
    </div>
</match-display-wrapper>
